export default __webpack_public_path__ + "static/media/frame-register-tablet.ddae50ac.png";